import { schema } from "normalizr";
import { FileExport } from "./file-export";

export const FileExports = new schema.Array(FileExport);
